<div class="space-y-6">

  <!-- Header -->
  <div class="flex justify-between items-center mb-6">
    <div>
      <h2 class="text-2xl font-semibold text-gray-800">System Settings</h2>
      <p class="text-sm text-gray-500 mt-1">Manage global platform configurations and variables.</p>
    </div>
    <div class="flex items-center gap-3">
      <button
        (click)="loadSettings()"
        [disabled]="isSaving"
        class="px-4 py-2 bg-gray-100 text-gray-700 text-sm rounded-lg hover:bg-gray-200 transition disabled:opacity-50">
        Discard Changes
      </button>
      <button
        (click)="saveAllSettings()"
        [disabled]="isSaving"
        class="flex items-center gap-2 px-6 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition font-medium disabled:opacity-50">
        <span *ngIf="!isSaving">Save All Settings</span>
        <div *ngIf="isSaving" class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
      </button>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="flex justify-center items-center py-20">
    <div class="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
  </div>

  <!-- Error State -->
  <div *ngIf="!isLoading && errorMessage" class="flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
    <span>{{ errorMessage }}</span>
    <button (click)="loadSettings()" class="ml-auto text-sm underline">Retry</button>
  </div>

  <!-- Form Fields Grid -->
  <div *ngIf="!isLoading && !errorMessage" class="bg-white rounded-2xl shadow p-6 border border-gray-100">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      
      <div *ngFor="let key of settingKeys" class="space-y-1">
        <label class="block text-sm font-medium text-gray-700 capitalize">
          {{ key.replace('_', ' ') }}
        </label>
        <div class="relative">
          <input *ngIf="settings[key] !== 'true' && settings[key] !== 'false'"
                 type="text" 
                 [(ngModel)]="settings[key]" 
                 [disabled]="isSaving"
                 class="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition disabled:bg-gray-100 disabled:text-gray-500">
          
          <select *ngIf="settings[key] === 'true' || settings[key] === 'false'"
                  [(ngModel)]="settings[key]" 
                  [disabled]="isSaving"
                  class="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition disabled:bg-gray-100 disabled:text-gray-500 bg-white">
            <option value="true">True (Enabled)</option>
            <option value="false">False (Disabled)</option>
          </select>
        </div>
      </div>

    </div>

    <div *ngIf="settingKeys.length === 0" class="py-12 text-center text-gray-500">
      No settings configurations found.
    </div>
  </div>

</div>
